import React, { useState } from 'react'
import { concatStyles } from 'src/utils'
import { loading } from 'src/assets/gif'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReplayIcon from '@material-ui/icons/Replay'
import { Typography } from '@material-ui/core'
import { useStyles } from './styles'
import { Button } from '../Button'

interface CustomLoadingProps {
  className?: string
  refetch?: () => Promise<any> | void
  isError?: boolean
}

export const Loading: React.FC<CustomLoadingProps> = ({ className, refetch, isError }) => {
  const classes = useStyles()
  const [isRefetching, setIsRefetching] = useState(false)

  const handleRefetch = async () => {
    if (!refetch || !isError) return

    try {
      setIsRefetching(true)
      await refetch()
    } finally {
      setIsRefetching(false)
    }
  }

  if (!isError || isRefetching) {
    return (
      <div className={concatStyles(classes.loadingWrapper, className)}>
        <img src={loading} alt='Loading' />
      </div>
    )
  }

  return (
    <div className={concatStyles(classes.errorWrapper, className)}>
      <div className={classes.errorIconSpot}>
        <div className={classes.errorIconOuterCircle}>
          <div className={classes.errorIconContainer}>
            <ErrorOutlineIcon className={classes.errorIcon} />
          </div>
        </div>
      </div>

      <div className={classes.errorTextContainer}>
        <Typography component='h3' className={classes.errorTitle}>
          Ops! Algo deu errado
        </Typography>
        <Typography component='p' className={classes.errorMessage}>
          Não conseguimos processar sua solicitação no momento. Verifique sua conexão e tente novamente.
        </Typography>
      </div>

      <Button onClick={handleRefetch} className={classes.retryButton}>
        <ReplayIcon className={classes.buttonIcon} />
        Tentar novamente
      </Button>
    </div>
  )
}
